import { 
  formatDate,
  compareDay,
  getDayByOffset,
  getNextDay,
} from '@/utils/baseDate'

const DEFAULT_FROM = [{
  city_id: 'BJS',
  city_name: '北京',
  id: 'BJS',
  name: '北京',
}]
const DEFAULT_TO = [{
  city_id: 'SHA',
  city_name: '上海',
  id: 'SHA',
  name: '上海',
}]

export default {
  selectCitys(state) {
    const {
      fromCitys = DEFAULT_FROM,
      toCitys = DEFAULT_TO,
      spFromCitys = DEFAULT_FROM,
      spToCitys = DEFAULT_TO,
    } = state.flightsQuery
    return {
      fromCitys,
      toCitys,
      // 特价
      spFromCitys,
      spToCitys,
    }
  },
  selectDate(state) {
    const defaultFromDate = formatDate(getNextDay(new Date()))
    const today = formatDate(new Date())
    let {
      fromDate = defaultFromDate,
      toDate,
      fuzzyDate,
    } = state.flightsQuery
    // 处理去程时间
    if(compareDay(today, fromDate) > -1) {
      fromDate = today
    }
    // 处理返程时间
    const next3 = formatDate(getDayByOffset(fromDate, 3))
    if(!toDate) {
      toDate = next3
    }
    if(compareDay(fromDate, toDate) > 0) {
      toDate = next3
    }
    // const next100 = formatDate(getDayByOffset(fromDate, 100))
    const after365 = formatDate(getDayByOffset(today, 365-1))
    // const maxDate = compareDay(next100, after365) > -1 ? after365 : next100
    const maxDate = after365
    if(compareDay(toDate, maxDate) > 0) {
      toDate = maxDate
    }
    // 处理模糊时间
    if(!fuzzyDate) {
      fuzzyDate = null
    }else {
      fuzzyDate.weeks = fuzzyDate.weeks ? fuzzyDate.weeks.sort() : []
      const currentDate = formatDate(new Date(), 'YYYY-MM')
      fuzzyDate.months = fuzzyDate.months.filter(i => compareDay(currentDate, i) < 1).sort()
    }

    return {
      fromDate,
      toDate,
      fuzzyDate,
    }
  },
  searchRetList(state) {
    return state.cityAirports.concat(state.airports)
  },
}
